/**
 * هر جدولِ ادمین پیش‌فرض فقط ۵ سطرِ اول را نشان می‌دهد و زیرش «بیشتر» دارد
 * (WHOSUP-277، خواسته‌ی صریح برای «تمامیِ صفحات»).
 *
 * چرا سراسری و نه یک کامپوننت: ۷۰-واندی جدول در ۲۶ فایل‌اند و هر جدولِ
 * تازه باید بی‌کار رفتار را بگیرد. پس یک ناظرِ DOM جدول‌ها را پیدا می‌کند،
 * روی جدولِ بلند `data-more` می‌گذارد (CSS بقیه‌ی سطرها را پنهان می‌کند) و
 * یک `<caption>` با دکمه به خودِ جدول اضافه می‌کند. فقط attribute و caption
 * دست می‌خورد — چیزهایی که React رویشان کاری ندارد — و هیچ سطری حذف نمی‌شود،
 * پس فیلتر و مرتب‌سازیِ خودِ جدول‌ها دست‌نخورده می‌ماند.
 */
const LIMIT = 5;

function sync(table: HTMLTableElement) {
  const body = table.tBodies[0];
  const n = body ? body.rows.length : 0;
  let cap = table.querySelector<HTMLTableCaptionElement>(':scope > caption.morecap');
  if (n <= LIMIT) {
    if (table.hasAttribute('data-more')) table.removeAttribute('data-more');
    if (cap) cap.remove();
    return;
  }
  if (!table.hasAttribute('data-more')) table.setAttribute('data-more', '');
  if (!cap) {
    cap = document.createElement('caption');
    cap.className = 'morecap';
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'linkbtn';
    btn.addEventListener('click', () => {
      table.toggleAttribute('data-all');
      sync(table);
    });
    cap.appendChild(btn);
    table.appendChild(cap);
  }
  const label = table.hasAttribute('data-all') ? 'کمتر' : `بیشتر (${n - LIMIT} سطرِ دیگر)`;
  const btn = cap.firstElementChild as HTMLButtonElement;
  if (btn.textContent !== label) btn.textContent = label;
}

export function installTableCollapse(root: HTMLElement) {
  let queued = false;
  const run = () => {
    queued = false;
    root.querySelectorAll('table').forEach(sync);
  };
  new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(run);
  }).observe(root, { childList: true, subtree: true });
  run();
}
